document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-editorial-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    function slideWidth() {
      var slide = track.querySelector('[data-carousel-slide]');
      return slide ? slide.getBoundingClientRect().width + 8 : 0;
    }

    prev && prev.addEventListener('click', function () {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });

    next && next.addEventListener('click', function () {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
  });
    var revealTargets = document.querySelectorAll('.scroll-reveal');
  if (revealTargets.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealTargets.forEach(function (el) { observer.observe(el); });
  }
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('.site-header');
      header.classList.toggle('is-menu-open');
    });
  });

document.querySelectorAll('[data-shop-toggle]').forEach(function (btn) {
  var panel = btn.closest('.site-header__left-shop').querySelector('[data-shop-panel]');

  function positionPanel() {
    var logo = document.querySelector('.hero-logo, .site-header__logo-inline, .site-header__logo');
    if (logo) {
      var rect = logo.getBoundingClientRect();
      panel.style.top = (rect.bottom + 20) + 'px';
    } else {
      panel.style.top = '140px';
    }
  }

  btn.addEventListener('click', function () {
    positionPanel();
    var isOpen = panel.classList.toggle('is-open');
    btn.classList.toggle('is-active', isOpen);
    btn.setAttribute('aria-expanded', isOpen);
  });
});
document.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
  toggle.addEventListener('click', function () {
    var panel = toggle.nextElementSibling;
    if (panel && panel.hasAttribute('data-accordion-panel')) {
      panel.classList.toggle('is-open');
    }
  });
});
});
